import base64url from 'base64url';
import { IEditMenuActionParams } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { getServerURL } from '../../../../../../Utils/getServerURL';
import { OversiktRapporterQuery_db_brevLayouts } from '../Queries/_QueryTypes/OversiktRapporterQuery';

export interface IEditorReportParams {
  DigiSign?: 'Ja' | 'Nej';
  Layout?: OversiktRapporterQuery_db_brevLayouts | null;
}

interface IPDFPreviewParams {
  reportName: 'AvenyPDFPreview';
  DBName: string;
  /** Delprogram (krävs) */
  SubsystemCode: string;
  /** Samlingsnamn (krävs) */
  CollectionName: string;
  /** PDF-rapportmall (base64-kodad JSON, krävs) */
  ReportTemplate: string;
  /** Exportera som PNG istället för PDF */
  RenderPNG?: boolean;
  /** Layout-ID */
  Layout?: string | null;
  /** Layoutparametrar */
  LayoutOptions?: string;
  /** Rapportparametrar */
  Params?: string;
  /** Rutin-ID */
  Routine?: number;
}

const convertLayoutOptionsToJson = (paramString: string): string => {
  // Split by semicolon to get individual parameters
  const pairs = paramString.split(';');

  // Create an object to store the key-value pairs
  const result: Record<string, string> = {};

  // Process each key=value pair
  for (const pair of pairs) {
    const trimmedPair = pair.trim();
    if (trimmedPair) {
      const [key, value] = trimmedPair.split('=');
      if (key && value !== undefined) {
        result[key.trim()] = value.trim();
      }
    }
  }

  // Convert to JSON string
  return JSON.stringify(result);
};

export const handlePreviewClick =
  (
    activeDatabase: string,
    routineId: number | undefined,
    previewParams: IEditorReportParams
  ) =>
  ({ businessDataFormContext }: IEditMenuActionParams) => {
    const currentValues = businessDataFormContext?.formState.currentValues;
    const { Layout, ...previewParamsWithoutLayout } = previewParams;
    const layoutId = Layout?.id || null;
    const args: IPDFPreviewParams = {
      reportName: 'AvenyPDFPreview',
      DBName: activeDatabase,
      SubsystemCode: currentValues?.SUBSYSTEMCODE || '',
      CollectionName: currentValues?.COLLECTION_NAME || '',
      ReportTemplate: base64url.toBase64(
        base64url(currentValues?.PdfJson || '')
      ),
      Layout: layoutId,
      LayoutOptions: currentValues?.LAYOUT_OPTIONS
        ? convertLayoutOptionsToJson(currentValues.LAYOUT_OPTIONS)
        : undefined,
      Routine: routineId,
      Params: JSON.stringify(previewParamsWithoutLayout),
    };

    fetch(`${getServerURL()}/report`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(args),
    })
      .then(async response => {
        if (!response.ok) {
          const text = await response.text();
          throw new Error(text);
        }

        response.blob().then(blob => {
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'application/pdf' })
          );

          // Open PDF in new tab
          window.open(url, '_blank');

          // Clean up the object URL after a short delay to prevent memory leaks
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
        });
      })
      .catch(e => {
        throw new Error('Fel vid förhandsgranskning av PDF. ' + e);
      });
  };
